<div class="send-data">
  <app-background [justBackground]="true"></app-background>

  <div class="content">
    <ng-container *ngIf="!dataSent">
      <h1>Verstuur je data naar de onderzoeker</h1>

      <p>
        Je staat op het punt de gebruiksgegevens (anoniem) te verzenden naar de onderzoeker.
        Doe dit alleen als je hierom gevraagd wordt.
      </p>

      <div class="download-share-btn">
        <button (click)="dataSent = !dataSent; sendData()">Verzenden</button>
        <button (click)="downloadDataLocally()">Download data</button>
      </div>

      <div style="padding: 1.5rem 0">
        <a routerLink="../">Terug naar beginscherm</a>
      </div>

      <div class="small-text-box">
        Gebruiker ID:
        <pre>{{ userUid }}</pre>
      </div>
    </ng-container>

    <h1 *ngIf="dataSent">Bedankt voor het versturen van je data</h1>
    <p *ngIf="dataSent">Je gebruiksgegevens zijn succesvol verzonden naar de onderzoeker</p>

    <button (click)="dataSent = !dataSent" *ngIf="dataSent" routerLink="../">Terug naar beginscherm</button>
  </div>
</div>
